import { RootState } from "../configureStore";

const getSession = (state: RootState) => state.session;

export default getSession;
